module.exports = __webpack_public_path__ + "static/media/production-monitor.0e37e1c9.jpg";